import React from 'react';

const modalStyles = `
  .ticket-details-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9998;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ticket-details-modal {
    background: white;
    border-radius: 8px;
    max-width: 700px;
    width: 90%;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    animation: modalFadeIn 0.3s ease;
  }

  @keyframes modalFadeIn {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .ticket-modal-header {
    background: #453acd;
    color: white;
    padding: 15px 20px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .ticket-modal-title {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 600;
  }

  .ticket-modal-close {
    background: transparent;
    border: none;
    color: white;
    font-size: 1.5rem;
    cursor: pointer;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: background 0.2s ease;
  }

  .ticket-modal-close:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  .ticket-modal-body {
    padding: 20px;
  }

  .ticket-info-card {
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    margin-bottom: 15px;
    overflow: hidden;
  }

  .ticket-card-header {
    background: #f8f9fa;
    padding: 12px 15px;
    border-bottom: 1px solid #dee2e6;
  }

  .ticket-card-header h6 {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: #212529;
  }

  .ticket-card-body {
    padding: 15px;
  }

  .ticket-info-row {
    display: flex;
    margin-bottom: 15px;
  }

  .ticket-info-row:last-child {
    margin-bottom: 0;
  }

  .ticket-info-col {
    flex: 1;
    padding: 0 10px;
  }

  .ticket-info-col:first-child {
    padding-left: 0;
  }

  .ticket-info-col:last-child {
    padding-right: 0;
  }

  .ticket-info-label {
    font-weight: 600;
    color: #495057;
    font-size: 0.95rem;
    margin-bottom: 5px;
  }

  .ticket-info-value {
    color: #212529;
    font-size: 0.9rem;
  }

  .ticket-id-text {
    font-family: 'Courier New', monospace;
    color: #6c757d;
    font-size: 0.85rem;
    word-break: break-all;
  }

  .ticket-status-badge {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 4px;
    font-size: 0.85rem;
    font-weight: 500;
  }

  .ticket-status-success {
    background: #28a745;
    color: white;
  }

  .ticket-status-warning {
    background: #ffc107;
    color: #212529;
  }

  .ticket-status-info {
    background: #17a2b8;
    color: white;
  }

  .ticket-comment-box {
    padding: 12px;
    border-radius: 4px;
    font-size: 0.9rem;
    margin-top: 5px;
  }

  .ticket-comment-info {
    background: #d1ecf1;
    border: 1px solid #bee5eb;
    color: #0c5460;
  }

  .ticket-comment-warning {
    background: #fff3cd;
    border: 1px solid #ffeaa7;
    color: #856404;
  }

  .ticket-comment-light {
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    color: #6c757d;
  }

  .ticket-comment-secondary {
    background: #e2e3e5;
    border: 1px solid #d6d8db;
    color: #383d41;
  }

  .ticket-modal-footer {
    padding: 15px 20px;
    border-top: 1px solid #dee2e6;
    display: flex;
    justify-content: flex-end;
  }

  .ticket-btn-close {
    background: #6c757d;
    color: white;
    border: none;
    padding: 8px 20px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.95rem;
    transition: background 0.2s ease;
  }

  .ticket-btn-close:hover {
    background: #5a6268;
  }

  @media (max-width: 768px) {
    .ticket-details-modal {
      width: 95%;
      max-height: 95vh;
    }

    .ticket-info-row {
      flex-direction: column;
    }

    .ticket-info-col {
      padding: 0;
      margin-bottom: 15px;
    }
  }
`;

const TicketDetailsModal = ({ isOpen, onClose, ticketData }) => {
  if (!isOpen || !ticketData) return null;

  const getStatusClass = (status) => {
    if (status === 'completed') return 'ticket-status-success';
    if (status === 'inProgress') return 'ticket-status-warning';
    return 'ticket-status-info';
  };

  const getStatusText = (status) => {
    if (status === 'completed') return 'Completed';
    if (status === 'inProgress') return 'In Progress';
    return status || 'Submitted';
  };

  return (
    <>
      <style>{modalStyles}</style>
      <div className="ticket-details-modal-overlay" onClick={onClose}>
        <div className="ticket-details-modal" onClick={(e) => e.stopPropagation()}>
          <div className="ticket-modal-header">
            <h5 className="ticket-modal-title">Ticket Details</h5>
            <button
              type="button"
              className="ticket-modal-close"
              onClick={onClose}
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          
          <div className="ticket-modal-body">
            <div className="ticket-info-card">
              <div className="ticket-card-header">
                <h6>Ticket Information</h6>
              </div>
              <div className="ticket-card-body">
                <div className="ticket-info-row">
                  <div className="ticket-info-col">
                    <p className="ticket-info-label">Ticket ID:</p>
                    <p className="ticket-id-text">{ticketData._id}</p>
                  </div>
                  <div className="ticket-info-col">
                    <p className="ticket-info-label">Status:</p>
                    <span className={`ticket-status-badge ${getStatusClass(ticketData?.ticketStatus)}`}>
                      {getStatusText(ticketData?.ticketStatus)}
                    </span>
                  </div>
                </div>
                
                <div className="ticket-info-row">
                  <div className="ticket-info-col">
                    <p className="ticket-info-label">Created:</p>
                    <p className="ticket-info-value">
                      {new Date(ticketData.createdAt).toLocaleDateString()}
                    </p>
                  </div>
                  {ticketData?.ticket?.updatedAt && ticketData?.ticket?.updatedAt !== ticketData?.createdAt && (
                    <div className="ticket-info-col">
                      <p className="ticket-info-label">Last Updated:</p>
                      <p className="ticket-info-value">
                        {new Date(ticketData?.ticket?.updatedAt).toLocaleDateString()}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="ticket-info-card">
              <div className="ticket-card-header">
                <h6>Request Details</h6>
              </div>
              <div className="ticket-card-body">
                <div className="ticket-info-row">
                  <div className="ticket-info-col">
                    <h6 className="ticket-info-label">User Comment:</h6>
                    {ticketData?.ticket?.userComment ? (
                      <div className="ticket-comment-box ticket-comment-info">
                        {ticketData?.ticket?.userComment}
                      </div>
                    ) : (
                      <div className="ticket-comment-box ticket-comment-light">
                        No comment provided
                      </div>
                    )}
                  </div>
                  
                  <div className="ticket-info-col">
                    <h6 className="ticket-info-label">Admin Comment:</h6>
                    {ticketData?.ticket?.adminComment || ticketData?.ticket?.actionNote ? (
                      <div className="ticket-comment-box ticket-comment-warning">
                        {ticketData?.ticket?.adminComment || ticketData?.ticket?.actionNote}
                      </div>
                    ) : (
                      <div className="ticket-comment-box ticket-comment-light">
                        No admin comment yet
                      </div>
                    )}
                  </div>
                </div>
                
                {ticketData?.requestStatus && (
                  <div style={{ marginTop: '15px' }}>
                    <h6 className="ticket-info-label">Status Details:</h6>
                    <div className="ticket-comment-box ticket-comment-secondary">
                      {ticketData.requestStatus}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="ticket-modal-footer">
            <button
              type="button"
              className="ticket-btn-close"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default TicketDetailsModal;
